module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_sonho.d49620e0.png";